import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTMobile",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(t, i, r, v, u, a) {
  return d(), n("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--t-mobile"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "T Mobile",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    e("path", {
      d: "M9.169 14.057H6.597v-2.571H9.17v2.571Z",
      fill: "#E20975"
    }, null, -1),
    e("path", {
      d: "M6.597 5.571v4.372h.772v-.129c0-2.057 1.157-3.343 3.342-3.343h.129v9.258c0 1.285-.514 1.8-1.8 1.8h-.386v.9h6.686v-.9h-.386c-1.286 0-1.8-.515-1.8-1.8V6.47h.129c2.186 0 3.343 1.286 3.343 3.343v.129h.771V5.57h-10.8Z",
      fill: "#E20975"
    }, null, -1),
    e("path", {
      d: "M14.826 14.057h2.571v-2.571h-2.571v2.571Zm3.302-4.75v.132h.105c.05 0 .085-.014.085-.064 0-.044-.029-.068-.085-.068h-.105Zm.17.205.108.167h-.102l-.097-.16h-.079v.16h-.085v-.45h.196c.1 0 .164.055.164.143a.137.137 0 0 1-.105.14Zm.293-.05a.379.379 0 0 0-.384-.395.38.38 0 0 0-.387.396c0 .228.162.395.387.395.223 0 .384-.167.384-.395Zm.087 0a.46.46 0 0 1-.471.48.463.463 0 0 1-.474-.48c0-.278.202-.48.474-.48a.46.46 0 0 1 .471.48Z",
      fill: "#E20975"
    }, null, -1)
  ])], 10, h);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=t-mobile.js.map
